import { render, staticRenderFns } from "./goETC.vue?vue&type=template&id=11e7227c&scoped=true"
import script from "./goETC.vue?vue&type=script&lang=js"
export * from "./goETC.vue?vue&type=script&lang=js"
import style0 from "./goETC.vue?vue&type=style&index=0&id=11e7227c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e7227c",
  null
  
)

export default component.exports